import * as React from 'react';

import defaultClassroomImage from 'assets/images/default-classroom.png';
import {
    CardBarUser,
    CardDetails,
    CardMedia,
    CardMediaOverlayText,
    CardStandard,
} from 'ui/components/Card/Cards';

import messages from './displayMessages';

import { WrappedMessage } from 'utils';

interface LearnerDashboardActiveClassroomCardProps {
    title: string;
    text: string;
    code: React.ReactNode;
    imageUrl?: string;
    educatorName?: string;
    educatorUsername: string;
    onClick: () => void;
    showSkeleton?: boolean;
}

export const LearnerDashboardActiveClassroomCard: React.SFC<LearnerDashboardActiveClassroomCardProps> = (
    { title, text, imageUrl, showSkeleton,code, educatorName, educatorUsername, onClick }) => (
        <CardStandard
            media={
                <CardMedia
                    mediaUrl={imageUrl || defaultClassroomImage}
                    overlays={
                        [
                            <CardMediaOverlayText
                                message={
                                    <WrappedMessage
                                        message={messages.classCodeOverlayText}
                                        values={{ code }}
                                    />
                                }
                                additionalStyling='media-overlay-position-bottom-left'
                                key='classCodeCardMediaOverlay'
                            />,
                        ]
                    }
                    showSkeleton={showSkeleton}
                />
            }
            details={
                <CardDetails
                    title={title}
                    text={text}
                    showSkeleton={showSkeleton}
                />
            }
            barBottom={
                <CardBarUser
                    username={educatorUsername}
                    text={educatorName ? educatorName : ''}
                    onClick={onClick}
                    showSkeleton={showSkeleton}
                />
            }
            showBarBottomSeparator={false}
            showBarTopSeparator={false}
            onClick={onClick}
            additionalStyling='learner-dashboard-card-component'
            showSkeleton={showSkeleton}
        />
    );
